export type Point3={x:number;y:number;z:number};
/** Position and its derivative use the same path, so the mesh cannot yaw/pitch
 * toward a different trajectory. Target velocity is per unit of progress.
 * Coordinates are world x/up/z, not tile x/y. */
export function sampleFlight(from:Point3,to:Point3,progress:number,arcHeight:number,targetVelocity:Point3={x:0,y:0,z:0}){
 const t=Math.max(0,Math.min(1,progress)),dx=to.x-from.x,dy=to.y-from.y,dz=to.z-from.z;
 return {
  position:{x:from.x+dx*t,y:from.y+dy*t+Math.sin(t*Math.PI)*arcHeight,z:from.z+dz*t},
  tangent:{x:dx+t*targetVelocity.x,y:dy+Math.PI*Math.cos(t*Math.PI)*arcHeight+t*targetVelocity.y,z:dz+t*targetVelocity.z}
 };
}
